import { useEffect, useState } from 'react';
import { injectScript } from '../services/tracking/provider/services/script-loader.service';

const CONSENT_KEY = 'clarity_consent';
const CLARITY_PROJECT_ID = 't0wp0chue3';

function loadClarity(): void {
  injectScript(`
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${CLARITY_PROJECT_ID}");
  `);
}

/**
 * Gate de consentimento LGPD para o Microsoft Clarity (heatmaps/gravação de sessão podem
 * capturar PII). Só carrega o script após opt-in explícito; decisão fica em localStorage.
 */
export function ClarityConsentGate() {
  const [decision, setDecision] = useState<'pending' | 'granted' | 'denied'>('pending');

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored === 'granted' || stored === 'denied') {
      setDecision(stored);
    }
  }, []);

  useEffect(() => {
    if (decision === 'granted') {
      loadClarity();
    }
  }, [decision]);

  if (decision !== 'pending') return null;

  function handleDecision(value: 'granted' | 'denied') {
    localStorage.setItem(CONSENT_KEY, value);
    setDecision(value);
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-[9999] flex flex-col items-center gap-3 border-t border-medium-gray bg-white p-4 text-sm shadow-[0_-2px_10px_rgba(0,0,0,0.08)] sm:flex-row sm:justify-between">
      <p className="text-text-secondary">
        Usamos cookies de análise para entender como você usa o checkout e melhorar sua experiência. Você pode
        aceitar ou recusar.
      </p>
      <div className="flex shrink-0 gap-2">
        <button
          type="button"
          onClick={() => handleDecision('denied')}
          className="rounded-md border border-medium-gray px-4 py-2 text-text-secondary hover:bg-light-gray"
        >
          Recusar
        </button>
        <button
          type="button"
          onClick={() => handleDecision('granted')}
          className="rounded-md bg-primary px-4 py-2 text-white hover:bg-primary-dark"
        >
          Aceitar
        </button>
      </div>
    </div>
  );
}
